import { atom } from 'recoil';

export const modalState = atom<any>({
  key: "modalState",
  default:[],
});
